import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { LeadsService } from '../leads/leads.service';
import { AuthService } from '../auth.service';
import { NotificationService } from '../shared/notification.service';
import { Router } from '@angular/router';
import { ReportsService } from '../shared/reports.service';
import { StockPicked, StockPickedGroup, StockPickedItem } from '../models/leads';
import * as XLSX from 'xlsx';
import { Subscription } from 'rxjs';
import { WebsocketsService } from '../shared/websockets.service';

@Component({
  selector: 'app-wip-storeroom',
  templateUrl: './wip-storeroom.component.html',
  styleUrls: ['./wip-storeroom.component.less']
})
export class WipStoreroomComponent implements OnInit, OnDestroy {

  constructor(
    private leadsService: LeadsService,
    public auth: AuthService,
    private notification: NotificationService,
    private router: Router,
    private reportsService: ReportsService,
    public websocketService: WebsocketsService) { }

  isLoading = false;
  isCompletedLoading = false;
  pageSize = 20;

  isCustomerDetailsModalVisible = false;
  storeRoom: StockPicked[] = [];
  completedStock: StockPicked[] = [];

  tableData: StockPickedGroup[] = [];

  dateSelect = [new Date(), new Date()];

  public storeRoomSummaryItems: StockPicked[] = [];
  public selectedstoreRoomSummaryItem: StockPicked;
  public storeRoomSummaryItemsClosed: StockPicked[] = [];
  private loadingStoreRoom: Subscription;
  showAllPicked = false;

  @HostListener("window:scroll", [])
  onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - (document.body.scrollHeight * 0.1)) {
      // you're at the bottom of the page
      this.pageSize += 10;
    }
  }

  resetTable() {
    this.pageSize = 20;
  }

  ngOnInit(): void {
    this.isLoading = true;
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();

    this.dateSelect = [
      new Date(year, month, day, 23, 59, 59, 999),  // Start of day
      new Date(year, month, day, 23, 59, 59, 999)  // End of day
    ];

    this.loadingStoreRoom = this.websocketService.MessageObservable().subscribe(
      (message) => {
        // Update your array based on the message
        if (message.type === 14) {
          this.getStockPicked();
        }
      },
      (error) => {
        console.error('WebSocket error in component:', error);
      }
    );
    this.getStockPicked();
  }

  ngOnDestroy(): void {
    if (this.loadingStoreRoom) {
      this.loadingStoreRoom.unsubscribe();
    }
  }

  getStockPicked() {
    this.leadsService.getStockPicked().subscribe({
      next: val => {
        this.storeRoom = val;
        this.storeRoom.forEach(item => {
          item.pickedQty = item.pickedQty > item.qty ? item.qty : item.pickedQty;
        });

        // this.storeRoom = this.storeRoom.sort((a, b) => b.dt.toLocaleString().localeCompare(a.dt.toLocaleString()));

        this.groupedData();

        this.isLoading = false;
        // this.getCompletedStockPicked(this.dateSelect);      
      },
      error: err => {
        this.notification.handleError(err);
        this.isLoading = false;
      }
    });
  }

  getCompletedStockPicked(dateSelect: Date[]) {
    this.isCompletedLoading = true;
    this.leadsService.getCompletedStockPicked(dateSelect).subscribe({
      next: val => {
        this.completedStock = val;
        this.completedStock = this.completedStock.sort((a, b) => {
          const dateA = new Date(a.dt);
          const dateB = new Date(b.dt);
          // Compare by day first
          const dayDiff = dateB.getDate() - dateA.getDate();
          if (dayDiff !== 0) return dayDiff;
          // If days are the same, compare by time
          return dateB.getTime() - dateA.getTime();
        });
        this.isCompletedLoading = false;
      },
      error: err => {
        this.notification.handleError(err);
        this.isCompletedLoading = false;
      }
    });
  }

  generateTimeString(minutes: number): string {
    if (minutes < 0) minutes = minutes * -1;
    if (minutes < 60) return minutes + " minutes";
    if (minutes < 60 * 24) return Math.trunc(minutes / 60).toString() + " hours"
    return Math.trunc(minutes / 60 / 24) + " days";
  }

  getRowWarning(minutes: number): number {
    if (minutes < 0) minutes = minutes * -1;
    if (minutes > 1440 && minutes < 10080) {
      return 1;
    }
    else if (minutes >= 10080) {
      return 2;
    }
    else {
      return 0;
    }
  }

  updateStockPicked(item: StockPicked) {
    let selectedStockPickedItem: StockPickedItem = new StockPickedItem();
    let selectedStockPickedArray: StockPickedItem[] = [];

    item.qty = item.qty - item.pickedQty;

    let stockPicked = item.qty === 0 ? 2 : 1; // 1 = partially picked, 2 = fully picked

    selectedStockPickedItem.orderId = item.orderId ? item.orderId : 0; // Assuming orderId is the same as quoteId
    selectedStockPickedItem.orderLineId = item.orderLineId ? item.orderLineId : 0; // Assuming orderLineId
    selectedStockPickedItem.quoteId = item.quoteId ? item.quoteId : 0;
    selectedStockPickedItem.quoteLineId = item.quoteLineId ? item.quoteLineId : 0;
    selectedStockPickedItem.msfId = item.msfId;
    selectedStockPickedItem.qty = item.qty;
    selectedStockPickedItem.stockPicked = stockPicked
    selectedStockPickedItem.comments = item.comments;
    selectedStockPickedItem.userId = item.userId;
    selectedStockPickedItem.pickedQty = item.pickedQty;
    selectedStockPickedItem.isTyre = item.isTyre;

    selectedStockPickedArray.push(selectedStockPickedItem);

    // Insert all the None-Tyre child items if parent qty is 0

    if (item.qty === 0 && !this.storeRoom.filter(val => val !== item).some(val => val.quoteId === item.quoteId && val.orderId === item.orderId && val.isTyre) && item.isTyre) {
      selectedStockPickedArray = selectedStockPickedArray.concat(this.storeRoom.filter(val => val.quoteId === item.quoteId && val.orderId === item.orderId && !val.isTyre).map(val => {
        let childItem: StockPickedItem = new StockPickedItem();
        childItem.orderId = val.orderId ? val.orderId : 0;
        childItem.orderLineId = val.orderLineId ? val.orderLineId : 0; // Assuming orderLineId
        childItem.quoteId = val.quoteId ? val.quoteId : 0;
        childItem.quoteLineId = val.quoteLineId ? val.quoteLineId : 0;
        childItem.msfId = val.msfId;
        childItem.qty = val.qty;
        childItem.stockPicked = stockPicked;
        childItem.comments = val.comments;
        childItem.userId = val.userId;
        childItem.pickedQty = val.pickedQty;
        childItem.isTyre = val.isTyre; return childItem;
      }) as unknown as StockPickedItem);
    }

    item.pickedQty = item.qty;

    this.leadsService.updateStockPicked(selectedStockPickedArray).subscribe({
      next: val => {
        const index = this.storeRoom.findIndex(val => {
          if (item.orderId !== 0)
            return (val.orderId === item.orderId);
          else
            return (val.quoteId === item.quoteId);
        });
        if (item.qty === 0) {
          this.storeRoom = this.storeRoom.filter(val => val !== item);

          if (!this.storeRoom.some(val => val.quoteId === item.quoteId && val.orderId === item.orderId && val.isTyre) && item.isTyre) {
            this.storeRoom = this.storeRoom.filter(val => !(val.quoteId === item.quoteId && val.orderId === item.orderId && !val.isTyre));
          }
        }
        this.storeRoom = [...this.storeRoom];
        this.groupedData();

        this.completedStock.push(item);
      },
      error: err => {
        this.notification.handleError(err);
      },
    });
  }


  selectItem(item: StockPicked) {
    this.isCustomerDetailsModalVisible = true;
    this.selectedstoreRoomSummaryItem = item;
  }

  filterCompletedStockPicked(result: Date[]): void {
    this.dateSelect = result;
    this.dateSelect[0].setHours(23, 59, 59, 999); // Set end of day
    this.dateSelect[1].setHours(23, 59, 59, 999); // Set end of day

    this.completedStock = [];

    this.getCompletedStockPicked(this.dateSelect);
  }

  availableStock(): StockPicked[] {
    return this.storeRoom.filter(item => item.stockPicked !== 2);
  }

  stockComplete(): StockPicked[] {
    return this.completedStock.filter(item => (item.stockPicked === 2 && this.showAllPicked ? item.isTyre : true));
    // && (item.dt >= this.dateSelect[0] && item.dt <= this.dateSelect[1])
  }

  exportArrayToExcel(headers: string[], data: any[], fileName: string): void {
    // Create CSV content
    let csvContent = '\uFEFF'; // UTF-8 BOM for Excel

    // Add headers
    csvContent += headers.join('\t') + '\n';

    // Add data rows
    data.forEach(row => {
      csvContent += row.join('\t') + '\n';
    });

    // Create Blob
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create and trigger download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.xls`;
    document.body.appendChild(link);
    link.click();

    // Clean up
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    }, 100);
  }

  camelCaseToSpaced(str: string): string {
    return str
      // Insert space before capital letters
      .replace(/([A-Z])/g, ' $1')
      // Capitalize first letter
      .replace(/^./, firstChar => firstChar.toUpperCase())
      // Trim any extra spaces
      .trim();
  }

  getSpacedKeysFromArray(array: any[]): string[] {
    if (!array || array.length === 0) return [];

    // Get all unique keys from all objects in array
    const allKeys = array.reduce((keys, obj) => {
      return [...new Set([...keys, ...Object.keys(obj)])];
    }, [] as string[]);

    // Convert each key to spaced format
    return allKeys.map(key => this.camelCaseToSpaced(key));
  }

  downloadExcel(): void {
    let data = this.completedStock.filter(item => (this.showAllPicked ? item.isTyre : true)).map(({ customerName, stockCode, description, dt, qty, assignedTo, comments, availableSOH, vehicleReg, vehicleMake, vehicleModel, jobCardNumber, SFReference, ...rest }) => ({ customerName, stockCode, dt, qty, assignedTo, comments, description, availableSOH, vehicleReg, vehicleMake, vehicleModel, jobCardNumber, SFReference }));
    // const formattedData = data.map(item => ({
    //   ...item, // Copy all existing properties
    //   dt: item.dt.toISOString() // Convert date to a readable string
    // }));

    const headers = this.getSpacedKeysFromArray(data);
    // this.exportArrayToExcel(headers, data, 'Stock Picked Data');
    this.exportToExcel(data, 'Stock_Picked_Data.xlsx');
  }

  exportToExcel(data, fileName = 'export.xlsx') {
    // Ensure SheetJS is available
    if (typeof XLSX === 'undefined') {
      return;
    }

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert array of objects to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data, {
      header: [
        'customerName',
        'stockCode',
        'description',
        'dt',
        'qty',
        'assignedTo',
        'comments',
        'availableSOH',
        'vehicleReg',
        'vehicleMake',
        'vehicleModel',
        'jobCardNumber',
        'SFReference'
      ],
      skipHeader: false // Include headers in the first row
    });

    // Auto-size columns for better readability
    worksheet['!cols'] = [
      { wch: 40 }, // customerName
      { wch: 20 }, // stockCode
      { wch: 50 }, // description
      { wch: 9 }, // dt (date)
      { wch: 10 },  // qty
      { wch: 15 }, // assignedTo
      { wch: 30 }, // comments
      { wch: 12 }, // availableSOH
      { wch: 15 }, // vehicleReg
      { wch: 15 }, // vehicleMake
      { wch: 15 }, // vehicleModel
      { wch: 15 },  // jobCardNumber
      { wch: 15 }  // SFReference
    ];

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Data');

    // Generate and download the Excel file
    XLSX.writeFile(workbook, fileName);
  }

  updateArray(items: StockPicked[]) {

    for (let item of items) {
      item.pickedQty = item.pickedQty === 0 ? item.qty : item.pickedQty;
      let itemExists = this.storeRoom.some(val => val.msfId === item.msfId && val.quoteLineId === item.quoteLineId);
      this.storeRoom.filter(val => val.msfId === item.msfId).map(val => val.availableSOH = item.availableSOH);
      if (itemExists) {
        this.storeRoom = this.storeRoom.map(val => val.quoteLineId === item.quoteLineId ? { ...val, qty: item.qty, jobCardNumber: item.jobCardNumber, isPickable: item.isPickable } : val);
      }
      else
        this.storeRoom.push(item);
    }
    this.storeRoom = [...this.storeRoom];
    this.groupedData();
  }

  calculateRealSOH(item: StockPicked) {
    const totalQty = this.storeRoom.filter(val => val.msfId === item.msfId).map(item => item.qty).reduce((sum, qty) => sum + qty, 0);
    return item.availableSOH + totalQty
  }

  groupedData() {
    // Group by quoteId
    const groupedByQuote = this.storeRoom.reduce((acc, item) => {
      if (!acc[item.quoteId] && item.quoteId !== 0) {
        acc[item.quoteId] = [];
      }
      if (item.quoteId === 0) return acc;
      acc[item.quoteId].push(item);
      return acc;
    }, {} as { [key: number]: StockPicked[] });

    // Group by orderId
    const groupedByOrder = this.storeRoom.reduce((acc, item) => {
      if (!acc[item.orderId] && item.orderId !== 0) {
        acc[item.orderId] = [];
      }
      if (item.orderId === 0) return acc;
      acc[item.orderId].push(item);
      return acc;
    }, {} as { [key: number]: StockPicked[] });

    let tableQuote = Object.keys(groupedByQuote).map(quoteId => {
      const items = groupedByQuote[quoteId];
      let serviceItem = new StockPicked()
      if (items.filter(item => item.isTyre).length === 0 && items.filter(item => !item.isTyre).length !== 0) {
        serviceItem = Object.assign(new StockPicked(), items.filter(item => !item.isTyre)[0]);
        serviceItem.orderId = 0;
        serviceItem.quoteId = 0;
        serviceItem.brandImage = 'other.jpg';
        serviceItem.description = 'CUSTOM STOCK ITEMS';
        serviceItem.qty = 0;
        serviceItem.availableSOH = 0;
        serviceItem.pickedQty = 0;
        serviceItem.isPickable = false;
      }

      const parentItems = items.filter(item => item.isTyre).length > 0 ? items.filter(item => item.isTyre) : [serviceItem] as StockPicked[];
      const childItems = items.filter(item => !item.isTyre);

      return {
        orderId: 0,
        quoteId,
        parentItems,
        childItems,
        dt: parentItems.length > 0 ? parentItems[0].dt : (childItems.length > 0 ? childItems[0].dt : new Date()),
        expand: false,
      };
    }) as unknown as StockPickedGroup[];

    let tableOrder = Object.keys(groupedByOrder).map(orderId => {
      const items = groupedByOrder[orderId];
      let serviceItem = new StockPicked()
      if (items.filter(item => item.isTyre).length === 0 && items.filter(item => !item.isTyre).length !== 0) {
        serviceItem = Object.assign(new StockPicked(), items.filter(item => !item.isTyre)[0]);
        serviceItem.orderId = 0;
        serviceItem.quoteId = 0;
        serviceItem.brandImage = 'other.jpg';
        serviceItem.description = 'CUSTOM STOCK ITEMS';
        serviceItem.qty = 0;
        serviceItem.availableSOH = 0;
        serviceItem.pickedQty = 0;
        serviceItem.isPickable = false;
      }

      const parentItems = items.filter(item => item.isTyre).length > 0 ? items.filter(item => item.isTyre) : [serviceItem] as StockPicked[];
      // const parentItems = items.filter(item => item.isTyre);
      const childItems = items.filter(item => !item.isTyre);

      return {
        orderId,
        quoteId: 0,
        parentItems,
        childItems,
        dt: parentItems.length > 0 ? parentItems[0].dt : (childItems.length > 0 ? childItems[0].dt : new Date()),
        expand: false,
      };
    }) as unknown as StockPickedGroup[];

    let tempData = this.tableData;

    this.tableData = tableQuote.concat(tableOrder);

    this.tableData = this.tableData.map(item => {
      const existingItem = tempData.find((val) => Number(val.quoteId) === Number(item.quoteId) && Number(val.orderId) === Number(item.orderId));
      if (existingItem) {
        return {
          ...item,
          expand: existingItem.expand
        };
      }
      return item;
    }).sort((a, b) => b.dt.toLocaleString().localeCompare(a.dt.toLocaleString()));
  }

  // Toggle expand/collapse
  toggleExpand(item: any): void {
    item.expand = !item.expand;
  }

  // Check if group has children
  hasChildren(group: StockPickedGroup): boolean {
    return group.childItems && group.childItems.length > 0;
  }

  getDateColor(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();

    const twoDaysAgo = new Date();
    twoDaysAgo.setDate(now.getDate() - 2);

    const oneDaysAgo = new Date();
    oneDaysAgo.setDate(now.getDate() - 1);

    if (date <= twoDaysAgo) {
      return '#a61d24';
    } else if (date <= oneDaysAgo) {
      return 'var(--warningcolor)';
    }

    return ''; // default color
  }
}
